import { ConfigSettingsService } from '../config-settings/config-settings.service';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { OidcConfigDocument } from '../../models/OidcConfigDocument';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class AuthConfigReaderService {
  private readonly http = inject(HttpClient);
  private readonly configService = inject(ConfigSettingsService);

  private oidcConfigDocument: Promise<OidcConfigDocument> | null = null;

  private get authBaseAddress(): string | null {
    return this.configService.appSettings.connection?.auth;
  }

  /**
   * Builds and returns the refresh token revocation url to be used on logout. The feature is only available
   * if a post logout uri is configured.
   */
  public async createRevocationUrl(): Promise<string | null> {
    const oidc = await this.getOidcConfigurationDocument();
    if (!oidc?.revocation_endpoint) {
      return null;
    }

    return oidc.revocation_endpoint;
  }

  public async getTokenEndpoint(): Promise<string> {
    const oidc = await this.getOidcConfigurationDocument();
    return oidc.token_endpoint;
  }

  private getOidcConfigurationDocument(): Promise<OidcConfigDocument> {
    if (!this.oidcConfigDocument) {
      const url = `${this.authBaseAddress}/.well-known/openid-configuration`;
      this.oidcConfigDocument = firstValueFrom(this.http.get<OidcConfigDocument>(url));
    }

    return this.oidcConfigDocument;
  }
}
